import { render, staticRenderFns } from "./AreasModal.vue?vue&type=template&id=5ab26fd0&scoped=true"
import script from "./AreasModal.vue?vue&type=script&lang=js"
export * from "./AreasModal.vue?vue&type=script&lang=js"
import style0 from "./AreasModal.vue?vue&type=style&index=0&id=5ab26fd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab26fd0",
  null
  
)

export default component.exports